<template>
    <div class="pub-page">
        <!-- 顶部卡片 -->
        <div class="top-card">
            <div class="project-info">
                <span class="info-item">
                    <span class="info-label">招标项目名称：</span>
                    <span class="info-value">{{ projectName }}</span>
                </span>
                <span class="info-sep"></span>
                <span class="info-item">
                    <span class="info-label">招标项目编号：</span>
                    <span class="info-value">{{ projectCode }}</span>
                </span>
            </div>
            <div class="top-actions">
                <el-button class="btn-primary" @click="handleAdd">
                    <i class="el-icon-plus"></i> 新增候选人公示
                </el-button>
                <el-button class="btn-back" @click="handleBack">
                    <i class="el-icon-arrow-left"></i> 返回
                </el-button>
            </div>
        </div>

        <!-- 表格卡片 -->
        <div class="table-card">
            <div class="table-header">
                <span class="header-title">中标候选人公示列表</span>
            </div>
            <el-table :data="tableData" border class="data-table">
                <el-table-column prop="no" label="NO." width="60" align="center" />
                <el-table-column prop="publicityName" label="公示名称" show-overflow-tooltip />
                <el-table-column prop="sectionName" label="标段名称" show-overflow-tooltip />
                <el-table-column prop="publicityDate" label="公示日期" width="120" align="center" />
                <el-table-column prop="deadline" label="截止日期" width="120" align="center" />
                <el-table-column prop="releaseDate" label="发布日期" width="120" align="center" />
                <el-table-column prop="status" label="发布状态" width="100" align="center">
                    <template slot-scope="scope">
                        <span class="status-tag" :class="`status-tag--${scope.row.statusType}`">
                            {{ scope.row.status }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="120" align="center" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="text" class="action-btn" @click="handleEdit(scope.row)">编辑</el-button>
                        <el-button type="text" class="action-btn action-btn--danger" @click="handleDelete(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-wrap">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :total="total"
                    :page-size="pageSize"
                    :current-page="currentPage"
                    @current-change="handlePageChange"
                />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CandidatePublicity',

    data() {
        return {
            projectName: '',
            projectCode: '',
            tableData: [],
            total: 1,
            pageSize: 10,
            currentPage: 1
        }
    },

    created() {
        this.projectName = this.$route.query.projectName || '中山大厦项目'
        this.projectCode = this.$route.query.projectCode || 'E1101050893002128'
        this.loadData()
    },

    methods: {
        loadData() {
            this.tableData = [
                {
                    no: 1,
                    publicityName: '中山大厦建设项目中标候选人公示',
                    sectionName: '第一标段',
                    publicityDate: '2025-10-20',
                    deadline: '2025-10-25',
                    releaseDate: '2025-10-20',
                    status: '公示中',
                    statusType: 'warning'
                }
            ]
            this.total = 1
        },

        handleBack() {
            this.$router.push({
                path: '/agentHome/projectWorkflow',
                query: { projectName: this.projectName, projectCode: this.projectCode }
            })
        },

        handleAdd() {
            this.$message.info('新增候选人公示')
        },

        handleEdit(row) {
            this.$message.info(`编辑：${row.publicityName}`)
        },

        handleDelete(row) {
            this.$confirm('确定删除该公示记录？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$message.success('删除成功')
            }).catch(() => {})
        },

        handlePageChange(page) {
            this.currentPage = page
        }
    }
}
</script>

<style lang="less" scoped>
.pub-page {
    background: #F2F4F7;
    min-height: 100vh;
    padding: 20px 16px;
}

// ===== 顶部卡片 =====
.top-card {
    margin: 0 auto 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fff;
    border-radius: 4px;
    padding: 14px 20px;
    flex-wrap: wrap;
    gap: 12px;
}

.project-info {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}

.info-item {
    font-size: 14px;
}

.info-label {
    color: #606266;
}

.info-value {
    color: #303133;
    font-weight: 500;
}

.info-sep {
    width: 1px;
    height: 16px;
    background: #DCDFE6;
    margin: 0 16px;
}

.top-actions {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
}

.btn-primary {
    background: #1890FF;
    border-color: #1890FF;
    color: #fff;
    border-radius: 4px;
    font-size: 14px;

    i { margin-right: 4px; }

    &:hover {
        background: #40A9FF;
        border-color: #40A9FF;
    }
}

.btn-back {
    background: #fff;
    border-color: #DCDFE6;
    color: #606266;
    border-radius: 4px;
    font-size: 14px;

    i { margin-right: 4px; }

    &:hover {
        color: #409EFF;
        border-color: #409EFF;
    }
}

// ===== 表格卡片 =====
.table-card {
    margin: 0 auto;
    background: #fff;
    border-radius: 4px;
}

.table-header {
    padding: 14px 20px;
    border-bottom: 1px solid #EBEEF5;
}

.header-title {
    font-size: 14px;
    font-weight: 600;
    color: #303133;
}

.data-table {
    border: none;
    border-radius: 0;

    /deep/ .el-table__header-wrapper th {
        background: #FAFAFA;
        color: #606266;
        font-weight: 500;
        font-size: 13px;
    }

    /deep/ .el-table__cell {
        padding: 13px 0;
        font-size: 13px;
        color: #606266;
    }
}

.status-tag {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 2px;
    font-size: 12px;
    border: 1px solid;

    &--success {
        color: #67C23A;
        border-color: #c2e7b0;
        background: #f0f9eb;
    }

    &--warning {
        color: #E6A23C;
        border-color: #faecd8;
        background: #fdf6ec;
    }

    &--info {
        color: #909399;
        border-color: #d3d4d6;
        background: #f4f4f5;
    }
}

.action-btn {
    color: #409EFF;
    font-size: 13px;
    padding: 0 4px;

    &--danger {
        color: #F56C6C;
    }
}

.pagination-wrap {
    display: flex;
    justify-content: flex-end;
    padding: 14px 16px;
    border-top: 1px solid #EBEEF5;
}
</style>
